module.exports = __webpack_public_path__ + "img/HZ-B5026.c926dc08.jpg";